module.exports = __webpack_public_path__ + "img/theroom_plant.b446b1cc.jpg";